import React, { useEffect } from "react";

/* ═══════════════════════════════════════════════
   GLOBAL CSS
═══════════════════════════════════════════════ */
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Plus Jakarta Sans', sans-serif; background: #fafaf8; color: #1a1a1a; }
  a { color: #16a34a; text-decoration: none; }
  a:hover { text-decoration: underline; }
`;

const ARTICLES = [
  {
    num: "1",
    title: "Introduction",
    content:
      "La présente Politique de Confidentialité a pour objet d’informer les utilisateurs de la plateforme TransTiGo sur la manière dont leurs données personnelles sont collectées, utilisées, protégées et partagées. TransTiGo accorde une importance particulière à la protection des données personnelles.",
  },
  {
    num: "2",
    title: "Responsable du traitement",
    content: "Le responsable du traitement des données est l’équipe de TransTiGo.",
  },
  {
    num: "3",
    title: "Données collectées",
    subsections: [
      {
        title: "Données d’identification",
        content: "Nom, prénom, numéro de téléphone, adresse email.",
      },
      {
        title: "Données de compte",
        content: "Identifiant utilisateur, mot de passe.",
      },
      {
        title: "Données de transaction",
        content: "Historique des réservations, paiements, montants.",
      },
      {
        title: "Données de localisation",
        content: "Ville de départ, arrivée, points de rendez-vous.",
      },
      {
        title: "Données techniques",
        content: "Adresse IP, appareil utilisé, logs de connexion.",
      },
    ],
  },
  {
    num: "4",
    title: "Finalités du traitement",
    content:
      "Les données sont utilisées pour fournir les services, gérer les réservations, assurer la sécurité, améliorer la plateforme, fournir un support client et prévenir les fraudes.",
  },
  {
    num: "5",
    title: "Partage des données",
    content:
      "Les données peuvent être partagées avec d'autres utilisateurs, les prestataires de paiement, les partenaires techniques et les autorités si nécessaire. TransTiGo ne vend jamais les données personnelles.",
  },
  {
    num: "6",
    title: "Conservation des données",
    content:
      "Les données sont conservées pendant la durée d’utilisation du compte, puis pendant une durée nécessaire pour respecter les obligations légales.",
  },
  {
    num: "7",
    title: "Sécurité des données",
    content:
      "Des mesures de sécurité sont mises en place : chiffrement, accès sécurisé, protection contre les accès non autorisés. Toutefois, aucun système n’est totalement sécurisé.",
  },
  {
    num: "8",
    title: "Droits des utilisateurs",
    content:
      "Les utilisateurs disposent d’un droit d’accès, de rectification, de suppression et d’opposition concernant leurs données personnelles.",
  },
  {
    num: "9",
    title: "Cookies",
    content:
      "La plateforme peut utiliser des cookies pour améliorer l’expérience utilisateur et analyser l’utilisation.",
  },
  {
    num: "10",
    title: "Géolocalisation",
    content:
      "Certaines fonctionnalités nécessitent l’accès à la localisation, activable ou désactivable par l’utilisateur.",
  },
  {
    num: "11",
    title: "Utilisation par les mineurs",
    content:
      "L’utilisation est réservée aux personnes majeures. Un mineur peut utiliser la plateforme sous la responsabilité d’un représentant légal.",
  },
  {
    num: "12",
    title: "Responsabilité des utilisateurs",
    content:
      "Les utilisateurs sont responsables des informations partagées et de leurs interactions avec les autres utilisateurs.",
  },
  {
    num: "13",
    title: "Transfert de données",
    content:
      "Les données peuvent être stockées sur des serveurs situés à l’étranger avec des garanties de sécurité appropriées.",
  },
  {
    num: "14",
    title: "Modification de la politique",
    content:
      "TransTiGo peut modifier cette politique à tout moment. Les utilisateurs seront informés en cas de changement important.",
  },
  {
    num: "15",
    title: "Contact",
    content:
      "Pour toute question relative à cette politique, vous pouvez contacter TransTiGo par email.",
  },
];

const Confidentialite = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={s.page}>
      <style>{globalCSS}</style>

      {/* Header */}
      <header style={s.header}>
        <a href="/" style={s.logo}>
          Trans<span style={{ color: "#16a34a" }}>TiGo</span>
        </a>
        <a href="/" style={s.backLink}>← Retour à l'accueil</a>
      </header>

      {/* Hero */}
      <div style={s.hero}>
        <div style={s.heroInner}>
          <div style={s.tag}>Légal</div>
          <h1 style={s.heroTitle}>
            Politique de<br />Confidentialité
          </h1>
          <p style={s.heroDated}>Dernière mise à jour : 20 avril 2026</p>
        </div>
      </div>

      {/* Content */}
      <main style={s.main}>
        <div style={s.container}>
          {/* TOC */}
          <div style={s.toc}>
            <div style={s.tocTitle}>Table des matières</div>
            <div style={s.tocGrid}>
              {ARTICLES.map(a => (
                <a key={a.num} href={`#art-${a.num}`} style={s.tocLink}>
                  <span style={s.tocNum}>{a.num}</span> {a.title}
                </a>
              ))}
            </div>
          </div>

          {/* Articles */}
          <div style={s.articles}>
            {ARTICLES.map(a => (
              <section key={a.num} id={`#art-${a.num}`} style={s.article}>
                <div style={s.articleNumRow}>
                  <div style={s.articleNum}>{a.num}</div>
                  <h2 style={s.articleTitle}>{a.title}</h2>
                </div>

                {a.content && (
                  <p style={s.articleText}>{a.content}</p>
                )}

                {a.subsections &&
                  a.subsections.map(sub => (
                    <div key={sub.title} style={s.subsection}>
                      <div style={s.subTitle}>{sub.title}</div>
                      <p style={s.articleText}>{sub.content}</p>
                    </div>
                  ))}
              </section>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={s.footer}>
        <div style={s.footerInner}>
          <div style={s.footerLogo}>
            Trans<span style={{ color: "#16a34a" }}>TiGo</span>
          </div>
          <div style={s.footerLinks}>
            <a href="/confidentialite" style={s.footerLink}>
              Politique de confidentialité
            </a>
            <a href="/conditions" style={s.footerLink}>
              Conditions générales
            </a>
            <a href="/contact" style={s.footerLink}>
              Contact
            </a>
          </div>
          <div style={s.footerCopy}>
            © 2025 TransTiGo · Madagascar
          </div>
        </div>
      </footer>
    </div>
  );
};

const s = {
  page:       { fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#fafaf8", color: "#1a1a1a", minHeight: "100vh" },
  header:     { position: "sticky", top: 0, zIndex: 300, background: "rgba(250,250,248,0.96)", backdropFilter: "blur(20px)", borderBottom: "0.5px solid rgba(0,0,0,0.07)", padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" },
  logo:       { fontSize: 18, fontWeight: 800, letterSpacing: -0.5, color: "#1a1a1a", textDecoration: "none" },
  backLink:   { fontSize: 13, color: "#666", textDecoration: "none", fontWeight: 500 },

  hero:       { background: "#1a1a1a", padding: "60px 24px 52px" },
  heroInner:  { maxWidth: 800, margin: "0 auto" },
  tag:        { display: "inline-block", fontSize: 10, fontWeight: 800, letterSpacing: "1.5px", textTransform: "uppercase", color: "#16a34a", background: "rgba(22,163,74,0.12)", border: "0.5px solid rgba(22,163,74,0.3)", padding: "4px 12px", borderRadius: 20, marginBottom: 20 },
  heroTitle:  { fontSize: 36, fontWeight: 800, color: "white", letterSpacing: -1, lineHeight: 1.15, marginBottom: 14 },
  heroDated:  { fontSize: 13, color: "rgba(255,255,255,0.35)", fontWeight: 500 },

  main:       { padding: "52px 24px 80px" },
  container:  { maxWidth: 800, margin: "0 auto", display: "flex", flexDirection: "column", gap: 40 },

  toc:        { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 16, padding: "24px 28px" },
  tocTitle:   { fontSize: 11, fontWeight: 800, letterSpacing: "1px", textTransform: "uppercase", color: "#999", marginBottom: 16 },
  tocGrid:    { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "8px 24px" },
  tocLink:    { fontSize: 12.5, color: "#444", textDecoration: "none", display: "flex", alignItems: "center", gap: 8, padding: "4px 0", transition: "color .15s" },
  tocNum:     { width: 22, height: 22, borderRadius: "50%", background: "#f0fdf4", color: "#16a34a", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0 },

  articles:   { display: "flex", flexDirection: "column", gap: 0 },
  article:    { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 14, padding: "28px 32px", marginBottom: 12, scrollMarginTop: 80 },
  articleNumRow: { display: "flex", alignItems: "center", gap: 14, marginBottom: 16 },
  articleNum: { width: 36, height: 36, borderRadius: "50%", background: "#1a1a1a", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0 },
  articleTitle: { fontSize: 16, fontWeight: 700, color: "#1a1a1a", letterSpacing: -0.3 },
  articleText: { fontSize: 14, color: "#444", lineHeight: 1.75 },

  defList:    { display: "flex", flexDirection: "column", gap: 10, marginTop: 4 },
  defItem:    { display: "flex", gap: 12, alignItems: "flex-start", background: "#fafaf8", border: "0.5px solid #f0f0ec", borderRadius: 10, padding: "10px 14px" },
  defTerm:    { fontSize: 12.5, fontWeight: 700, color: "#1a1a1a", minWidth: 120, flexShrink: 0 },
  defDef:     { fontSize: 13, color: "#555", lineHeight: 1.6 },

  subsection: { marginTop: 16, paddingTop: 16, borderTop: "0.5px solid #f4f4f0" },
  subTitle:   { fontSize: 13, fontWeight: 700, color: "#16a34a", marginBottom: 8 },

  footer:     { background: "#111", padding: "32px 24px" },
  footerInner:{ maxWidth: 800, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16, alignItems: "flex-start" },
  footerLogo: { fontSize: 16, fontWeight: 800, color: "white", letterSpacing: -0.5 },
  footerLinks:{ display: "flex", gap: 20, flexWrap: "wrap" },
  footerLink: { fontSize: 12, color: "rgba(255,255,255,0.4)", textDecoration: "none" },
  footerCopy: { fontSize: 11, color: "rgba(255,255,255,0.2)" },
};

export default Confidentialite;